import { useRef, useState } from "react";
import RenderAttributeInput, { AttributeFieldProps } from "./RenderAttributeInput";
import GetAttributeDefinition, { AttributeTargetType, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import Accordian from "../Accordian";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import ImageField from "./ImageField";
import ButtonField from "./ButtonsField";
import SelectField from "./SelectField";
import { getNodeRootStyleAttributeValue, getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import GradientBuilder from "../Menus/GraidentBuilder";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import ColorInputField from "./ColorInputField";


enum BackgroundType{
    Color,
    Image,
    Gradient,
    Auto,
}

export default function BackgroundField({label,definition,layoutObject,updateFunc,screenSize,saveFunc,siteData}:AttributeFieldProps){



    const [bgImage,setBgImage] = useState(getNodeRootStyleAttributeValue(layoutObject,screenSize,attributeTypes.backgroundImage));
    const [updateToggle,setUpdateToggle] = useState(false);
    const backgroundImageDef = GetAttributeDefinition(attributeTypes.backgroundImage);
    const backgroundSizeDef = GetAttributeDefinition(attributeTypes.backgroundSize);
    const backgroundPositionDef = GetAttributeDefinition(attributeTypes.backgroundPosition);
    const backgroundRepeatDef = GetAttributeDefinition(attributeTypes.backgroundRepeat);
    const backgroundAttachmentDef = GetAttributeDefinition(attributeTypes.backgroundAttachment);
    const bgColor =  layoutObject.typename!=wBComponentTypeNames.navigationBar? GetAttributeDefinition(attributeTypes.backgroundColor):GetAttributeDefinition("dropdownBg");
    const overlayDef = GetAttributeDefinition(componentAttributeTypes.overlayColor);

    const prevColor = useRef(GetComponentOrStyleValueFromDefinition(bgColor,layoutObject,screenSize));

    

  
    let inBgType = BackgroundType.Color;

    let imageString = bgImage;
    
     if(imageString.indexOf("gradient") > -1){
        inBgType = BackgroundType.Gradient;
    }
    else if(imageString.indexOf("url") > -1||imageString.indexOf("var(--image") > -1){
        inBgType = BackgroundType.Image;

    }

    const [bgType,setBgType] = useState<BackgroundType>(inBgType);

    const UpdateType = (newVal:BackgroundType)=>{
      
      if(newVal!==bgType){
        if(newVal == BackgroundType.Color){
          updateFunc(attributeTypes.backgroundColor,prevColor.current,AttributeTargetType.Style);
        }
        else{
          updateFunc(attributeTypes.backgroundColor,"",AttributeTargetType.Style);
        }

        setBgType(newVal);
        updateFunc(attributeTypes.backgroundImage,"",AttributeTargetType.Style);

        updateFunc(attributeTypes.backgroundAttachment,"",AttributeTargetType.Style);
        updateFunc(attributeTypes.backgroundSize,"",AttributeTargetType.Style);
        updateFunc(attributeTypes.backgroundPosition,"",AttributeTargetType.Style);
        updateFunc(attributeTypes.backgroundRepeat,"",AttributeTargetType.Style);
        updateFunc(componentAttributeTypes.overlayColor,"",AttributeTargetType.Component);
       
        setBgImage("")
      }


    }



    const udpateFuncWrapper = (  attribute: string,
      value: string,
      targetType: AttributeTargetType)=>{

        if(attribute === attributeTypes.backgroundImage){
          setBgImage(value);
        }

        else if(attribute == attributeTypes.backgroundAttachment){
          setUpdateToggle(!updateToggle);
        }
        else if(attribute == attributeTypes.backgroundColor){
            prevColor.current = value;
            updateFunc(attributeTypes.backgroundImage,"none",AttributeTargetType.Style);
        }

      updateFunc(attribute,value,targetType);
    }

 




    const isParallax = getNodeStyleAttributeValue(layoutObject,screenSize,attributeTypes.backgroundAttachment) === "fixed";

 // const wrappedLabel = <label className={bgImage.length<1?"not-updated":"updated"}>{label}</label>
    return (
      <div className="wb-input-group">
        {/* <Accordian label = {wrappedLabel} wrapperClass="" startExpanded = {false} observerSizeChanges={true}> */}
          <label>Type</label>
        <div className="wb-input-row">

            <button className={"invisible-button "+(bgType==BackgroundType.Color?"selected":"")}
          onClick={()=>{UpdateType(BackgroundType.Color)}}
          >Color
          </button>
          
          <button className={"invisible-button "+(bgType==BackgroundType.Image?"selected":"")}
          onClick={()=>{UpdateType(BackgroundType.Image)}}
          >Image
          </button>

          <button className={"invisible-button "+(bgType==BackgroundType.Gradient?"selected":"")}
          onClick={()=>{UpdateType(BackgroundType.Gradient)}}
          >Gradient
          </button>
  

        </div>

       
         
        {bgType == BackgroundType.Gradient &&
            <GradientBuilder  siteData={siteData}inGradient={bgImage} onUpdateGradient={(newGradient)=>{ udpateFuncWrapper(attributeTypes.backgroundImage,newGradient,AttributeTargetType.Style);}} />
        }
        { bgType == BackgroundType.Color && 
        <ColorInputField noPadding={true} label={"Color"} definition={bgColor} layoutObject={layoutObject} updateFunc={udpateFuncWrapper} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />

        }

        {bgType==BackgroundType.Image &&  <>
            <ImageField label={"Image"} definition={backgroundImageDef} layoutObject={layoutObject} updateFunc={udpateFuncWrapper} saveFunc = {saveFunc} screenSize={screenSize} siteData={siteData}/>
            
            <RenderAttributeInput label={"Overlay"} definition={overlayDef} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />

            <Accordian label={"Advanced"} wrapperClass="wb-input-group no-border" startExpanded={false} observerSizeChanges={true}>
            <RenderAttributeInput label={"Background"} definition={bgColor} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
            <SelectField label={"Image Position"} definition={backgroundPositionDef} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
            <ButtonField label={"Image Size"} definition={backgroundSizeDef} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
            <ButtonField label={"Image Repeat"} definition={backgroundRepeatDef} layoutObject={layoutObject} updateFunc={updateFunc} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData}/>
            
            <ButtonField label={"Image Parallax"} definition={backgroundAttachmentDef} layoutObject={layoutObject} updateFunc={udpateFuncWrapper} screenSize={screenSize} saveFunc={saveFunc} siteData={siteData} />
            
            {
                isParallax &&<div className="input-description relative" style={{background:"#f2f2f2",marginTop:"-12px",zIndex:5}}>Parallax is currently not supported on IOS devices. Recommended for desktop use only</div>
            }
            </Accordian>
            </>
        }
       
        

  
        {/* </Accordian> */}
        
     
      </div>
    );

}